<template>
    <div class="flex items-center">
        <div>
            <div class="flex justify-center items-center cursor-pointer"
                :class="[!isNewDesign ? 'check-inactive':'check-new-inactive']"
                :data-cy="$attrs['data-cy']"
                 @click="toggleCheck()">
                <div v-if="check" :class="[!isNewDesign ? 'check-active':'check-new-active']"></div>
            </div>
        </div>
        <div v-if="text != null" class="pl-2 text-16" :class="[!isNewDesign ? 'text-a-blue-2140a6':'text-a-black-000926']" v-html="text"></div>
        <div v-else class="pl-2">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "Checkbox",
    props: {
        check: { type: Boolean }, // v-model:check
        text: { type: String, default: null },
        isNewDesign: { type: Boolean, default: false },
    },
    methods: {
        toggleCheck: function() {
            let value = !this.check;
            this.$emit('onClick');
            this.$emit('update:check', value);
        },
    },
}
</script>
<style lang="scss" scoped>
.check-inactive {
    background-image: url('../../../assets/icon/ic-checkbox-inactive.svg');
    background-position: center left;
    background-repeat: no-repeat;
    background-size: 18px 18px;
    width: 18px;
    height: 18px;
}
.check-active {
    background-image: url('../../../assets/icon/ic-checkbox-active.svg');
    background-position: center left;
    background-repeat: no-repeat;
    background-size: 18px 18px;
    width: 18px;
    height: 18px;
}
.check-new-inactive {
    background-image: url('../../../assets/icon/ic-new-check-box-inactive.svg');
    background-position: center left;
    background-repeat: no-repeat;
    background-size: 18px 18px;
    width: 18px;
    height: 18px;
}
.check-new-active {
    background-image: url('../../../assets/icon/ic-new-check-box-active.svg');
    background-position: center left;
    background-repeat: no-repeat;
    background-size: 18px 18px;
    width: 18px;
    height: 18px;
}
</style>
